/**
 * Client Type Enum
 */
export enum ClientTypeEnum {
	/**
	 * Admin
	 */
	Admin = 'admin',
	/**
	 * Viewer
	 */
	Viewer = 'viewer',
}
